import React from "react";

interface CustomSkeletonProps {
  height?: string;
  width?: string;
  shape?: "rectangle" | "circle" | "curvedRectangle";
  style?: React.CSSProperties;
}

const CustomSkeleton: React.FC<CustomSkeletonProps> = ({
  height = "100%",
  width = "100%",
  shape = "rectangle",
  style = {},
}) => {
  const borderRadiusMapping = {
    circle: "50%",
    rectangle: "0",
    curvedRectangle: "8px",
  };

  const outerStyle: React.CSSProperties = {
    height,
    width,
    borderRadius: borderRadiusMapping[shape] || borderRadiusMapping.rectangle,
    overflow: "hidden",
    background: "#d4d4d4",
    display: "inline-block",
    position: "relative",
    ...style,
  };

  const shimmerStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
    borderRadius: "4px",
    marginBottom: "10px",
    backgroundImage: "linear-gradient(to right, #c5c5c5, #e7e7e7, #c5c5c5)",
    backgroundSize: "200% 100%",
    animation: "slide 1s infinite ease-in-out",
  };

  return (
    <>
      <style>
        {`
          @keyframes slide {
            0% { background-position: -100% 0; }
            100% { background-position: 100% 0; }
          }
        `}
      </style>
      <div style={outerStyle}>
        <div style={shimmerStyle}></div>
      </div>
    </>
  );
};

export default CustomSkeleton;
